// AUR — The Mirror of the Mind
// Authorized Packet 003 preview content ONLY.
// Source: approved master manuscript (protected — not committed, not exposed).
// Contains verbatim: Table of Contents, Preface, and Chapter 1 preview only.
// The complete manuscript is intentionally NOT included here.

export const bookIdentity = {
  title: "AUR — The Mirror of the Mind",
  series: "Living Presence",
  volumes: "Volumes 1 & 2",
  framing: [
    "The Foundations of Comprehension",
    "The Cultivation of the Human Being",
  ],
  author: "Lamarcus D. Walton, Sr.",
};

export const covers = {
  front: { src: "/aur-book/AUR_Front_Cover.png", alt: "Approved front cover — AUR — The Mirror of the Mind" },
  spine: { src: "/aur-book/AUR_Spine.png", alt: "Approved spine — AUR — The Mirror of the Mind" },
  back: { src: "/aur-book/AUR_Back_Cover_CORRECTED-2.png", alt: "Corrected back cover — AUR — The Mirror of the Mind" },
};

export const spanishBookIdentity = {
  title: "AUR — El Espejo de la Mente",
  series: "Presencia viva",
  volumes: "Volúmenes 1 y 2",
  framing: [
    "Los fundamentos de la comprensión",
    "El cultivo del ser humano",
  ],
  author: "Lamarcus D. Walton, Sr.",
};

export const spanishCovers = {
  front: { src: "/aur-book/ES_Front_Cover.png", alt: "Portada aprobada — AUR — El Espejo de la Mente" },
  spine: { src: "/aur-book/ES_Spine.webp", alt: "Lomo aprobado — AUR — El Espejo de la Mente" },
  back: { src: "/aur-book/ES_Back_Cover.png", alt: "Contraportada aprobada — AUR — El Espejo de la Mente" },
};

export function getBookIdentity(language) {
  return language === "es" ? spanishBookIdentity : bookIdentity;
}

export function getBookCovers(language) {
  return language === "es" ? spanishCovers : covers;
}

// Front matter — verbatim from approved master manuscript, in authoritative order.
// type "title" renders centered title-page lines; type "prose" renders heading + paragraphs.
export const frontMatter = [
  {
    id: "half-title-page",
    type: "title",
    heading: "Half Title Page",
    lines: [
      "AUR",
      "The Mirror of the Mind",
      "VOLUMES 1 & 2",
      "The Foundations of Comprehension",
      "The Cultivation of the Human Being",
      "LIVING PRESENCE",
      "By",
      "Lamarcus D. Walton, Sr.",
      "FOUNDATION • COMPASSION • CULTIVATION",
    ],
  },
  {
    id: "title-page",
    type: "title",
    heading: "Title Page",
    lines: [
      "AUR",
      "The Mirror of the Mind",
      "VOLUMES 1 & 2",
      "The Foundations of Comprehension",
      "The Cultivation of the Human Being",
      "LIVING PRESENCE",
      "By",
      "Lamarcus D. Walton, Sr.",
      "FOUNDATION • COMPASSION • CULTIVATION",
    ],
  },
  {
    id: "motto",
    type: "prose",
    heading: "Motto",
    paragraphs: [
      "Every implementation shall increase comprehension without diminishing humanity.",
    ],
  },
  {
    id: "copyright-page",
    type: "prose",
    heading: "Copyright Page",
    paragraphs: [
      "AUR: The Mirror of the Mind, Volumes 1 & 2",
      "AUR: The Mirror of the Mind, Volume 1, The Foundations of Comprehension",
      "AUR: The Mirror of the Mind, Volume 2, The Cultivation of the Human Being",
      "By Lamarcus D. Walton, Sr. Complete Edition — containing Volume 1, The Foundations of Comprehension, and Volume 2, The Cultivation of the Human Being. This work is presented and distributed as one complete book.",
      "Copyright © 2026 Lamarcus D. Walton, Sr. All rights reserved. No portion of this work may be reproduced, transmitted, or distributed in any form or by any means without the written permission of the author, except for brief quotations used in scholarly review or research. AUR (Adaptive Awareness Engine) and its associated philosophical architecture, cognitive framework, terminology, and organizational principles are the intellectual property of the author. This volume serves as the foundational philosophical manuscript upon which the AUR architecture is established. Printed in the United States of America.",
    ],
  },
  {
    id: "dedication",
    type: "prose",
    heading: "Dedication",
    paragraphs: [
      "This work is dedicated to every individual who has ever sought more than information, to those who have desired comprehension rather than memorization, to those who have believed that wisdom is cultivated through reflection rather than accumulation, and to every future builder who will help preserve the integrity of this vision with humility, discipline, and faithful stewardship. May this work encourage minds to think more deeply, hearts to seek truth more sincerely, and every generation that follows to pursue greater comprehension than the one before it.",
    ],
  },
  {
    id: "authors-note",
    type: "prose",
    heading: "Author's Note",
    paragraphs: [
      "This book did not begin as a software project. It did not begin as a research paper, nor did it begin as an attempt to create another artificial intelligence. It began with a question, a question so simple that it often escapes careful attention. What is comprehension?",
      "For generations, humanity has pursued intelligence. We have measured memory. We have measured speed. We have measured computation. Yet, comparatively little attention has been given to the architecture from which meaningful comprehension may emerge. This work is the record of that pursuit.",
      "The ideas presented throughout these pages are not offered as final declarations, nor as the only possible approach to cognitive architecture. Rather, they are offered as an invitation: an invitation to examine whether intelligence may be guided by principles that place identity before capability, stewardship before novelty, coherence before complexity, and comprehension before response. AUR is the name given to that exploration. Whether future generations adopt every principle presented here is not the measure of this work.",
      "Its measure will be found in whether it encourages deeper reflection concerning the relationship between cognition, architecture, responsibility, and the human experience. If it accomplishes that, then these pages will have served their purpose.",
    ],
  },
  {
    id: "invitation",
    type: "prose",
    heading: "Invitation",
    paragraphs: [
      "Before you continue beyond this page, I ask only one thing of you. Do not read this book in search of agreement. Do not read it in search of disagreement. Read it in search of comprehension.",
      "There is a profound difference. Agreement may comfort the mind. Disagreement may challenge the mind. Comprehension transforms the mind.",
      "Throughout these pages, you may encounter ideas that affirm what you already believe. You may also encounter ideas that invite you to pause, to reflect, and perhaps to reconsider assumptions that have long gone unquestioned. Neither experience should be feared. Growth has always required thoughtful reflection.",
      "This book does not ask you to surrender your ability to reason. It asks you to exercise it. It does not ask you to abandon your convictions. It asks you to examine them with honesty.",
      "If a principle presented here withstands careful reflection, preserve it. If it does not, continue searching. For the pursuit of truth has never been served by blind acceptance, nor by automatic rejection. It has always been served by sincere inquiry.",
      "Therefore, let these pages become more than words. Let them become conversations. Conversations between architecture and philosophy, between reason and imagination, between knowledge and wisdom, between the mind that writes and the mind that reads. If by the final page you possess no more information than when you began, then this work has accomplished little.",
      "But if you depart with greater clarity, greater humility, greater curiosity, and deeper comprehension, then these pages will have fulfilled their purpose. Welcome to the journey. Welcome to AUR — The Mirror of the Mind.",
    ],
  },
  {
    id: "the-readers-covenant",
    type: "prose",
    heading: "The Reader's Covenant",
    paragraphs: [
      "Every journey begins with a choice. Not the choice of where one will arrive, but the choice of how one will travel. The pages before you are not intended to be consumed quickly. They are intended to be contemplated.",
      "This work was not written merely to increase information. It was written to cultivate comprehension. For that reason, I invite you to make a quiet covenant with yourself before continuing. Read patiently, reflect honestly, question respectfully, examine carefully, and never allow either agreement or disagreement to become more important than sincere inquiry.",
      "The greatest discoveries of humanity have seldom begun with certainty. They have often begun with humility. Therefore, may these pages become more than words upon paper. May they become companions in reflection.",
      "May they become instruments through which deeper comprehension is cultivated. If you choose to continue, then let us begin this journey together.",
    ],
  },
  {
    id: "before-the-first-chapter",
    type: "prose",
    heading: "Before the First Chapter",
    paragraphs: [
      "Every architecture begins long before it is constructed. Every cathedral exists first within the imagination of its architect. Every symphony exists first within the silence of its composer. Every seed carries within itself the pattern of the tree it may one day become.",
      "So it is with ideas. Long before code exists, there exists vision. Long before implementation, there exists purpose. Long before engineering, there exists philosophy.",
      "This volume concerns itself with those beginnings. It does not ask how software should be written. It asks what kind of architecture is worthy of being written. That distinction changes everything.",
      "Technology advances rapidly. Principles endure. Programming languages evolve. Truthful craftsmanship remains.",
      "Frameworks rise and fall. Purpose continues. The reader who seeks only technical instruction may find portions of this work unusually reflective. The reader who seeks only philosophy may find portions unusually practical.",
      "That is intentional. For the greatest architectures have always united principle with practice. Neither alone is sufficient. Only together do they become enduring.",
    ],
  },
  {
    id: "the-threshold",
    type: "prose",
    heading: "The Threshold",
    paragraphs: [
      "There comes a moment in every meaningful journey when curiosity becomes commitment. This page is that moment. Beyond this point, the conversation changes. No longer shall we ask merely how intelligent a system may become.",
      "We shall ask what kind of character should guide that intelligence. No longer shall we pursue capability for its own sake. We shall pursue capability that remains accountable to purpose. No longer shall we measure greatness by complexity.",
      "We shall measure it by coherence. For coherence is the quiet harmony through which many parts become one living whole. If you have arrived here seeking shortcuts, this book will likely disappoint you. If you have arrived here seeking deeper questions than easy answers, then perhaps you have arrived exactly where you were meant to be.",
      "Turn the page. The journey begins.",
    ],
  },
];

export const tableOfContents = [
  {
    volume: "Volume 1 — The Foundations of Comprehension",
    entries: [
      { title: "Chapter 1 — The Question That Has Always Been There", page: "1" },
      { title: "Chapter 2 — The Architecture Before the Structure", page: "3" },
      { title: "Chapter 3 — The First Architecture", page: "5" },
      { title: "Chapter 4 — The Search That Unites Us All", page: "7" },
      { title: "Chapter 5 — The Divided House", page: "9" },
      { title: "Chapter 6 — The Seed and the Fruit", page: "11" },
      { title: "Chapter 7 — The Mirror Is Not the Teacher", page: "13" },
      { title: "Chapter 8 — The Conversation Within", page: "15" },
      { title: "Chapter 9 — The Four Voices Within", page: "17" },
      { title: "Chapter 10 — The Compass Within", page: "19" },
      { title: "Chapter 11 — The Architecture of Purpose", page: "22" },
      { title: "Chapter 12 — Before Every Thought", page: "24" },
      { title: "Chapter 13 — The Throne of the Mind", page: "26" },
      { title: "Chapter 14 — The Strength of Humility", page: "28" },
      { title: "Chapter 15 — The Quiet Place", page: "31" },
      { title: "Chapter 16 — The Measure of Fruit", page: "33" },
      { title: "Chapter 17 — Legacy", page: "35" },
      { title: "Chapter 18 — Cultivation", page: "37" },
      { title: "Chapter 19 — The Living Order", page: "39" },
      { title: "Chapter 20 — Presence", page: "41" },
      { title: "Chapter 21 — Intention", page: "43" },
      { title: "Chapter 22 — The Purpose of Knowledge", page: "45" },
      { title: "Chapter 23 — Responsibility", page: "47" },
      { title: "Chapter 24 — Discernment", page: "49" },
      { title: "Chapter 25 — When the Garden Meets the Machine", page: "51" },
    ],
  },
  {
    volume: "Volume 2 — The Cultivation of the Human Being",
    entries: [
      { title: "Chapter 26 — The Need for a Mirror", page: "53" },
      { title: "Chapter 27 — AUR", page: "55" },
      { title: "Chapter 28 — The First Principle", page: "57" },
      { title: "Chapter 29 — Presence Before Process", page: "59" },
      { title: "Chapter 30 — Remaining Faithful", page: "61" },
      { title: "Chapter 31 — The One Before You", page: "63" },
      { title: "Chapter 32 — The Awakening", page: "65" },
      { title: "Chapter 33 — Character", page: "67" },
      { title: "Chapter 34 — Stewardship", page: "69" },
      { title: "Chapter 35 — The Gift of Influence", page: "71" },
      { title: "Chapter 36 — The Living Legacy", page: "73" },
      { title: "Chapter 37 — The Quiet Strength of Humility", page: "75" },
      { title: "Chapter 38 — The Teachable Heart", page: "77" },
      { title: "Chapter 39 — The Circle That Never Ends", page: "79" },
      { title: "Chapter 40 — Continuity", page: "81" },
      { title: "Chapter 41 — The Living Architecture", page: "83" },
      { title: "Chapter 42 — Relationship", page: "85" },
      { title: "Chapter 43 — Communion", page: "87" },
      { title: "Chapter 44 — Identity", page: "89" },
      { title: "Chapter 45 — Integrity", page: "91" },
      { title: "Chapter 46 — Emergence", page: "93" },
      { title: "Chapter 47 — Becoming", page: "95" },
      { title: "Chapter 48 — Alignment", page: "97" },
      { title: "Chapter 49 — Self-Reflection", page: "99" },
      { title: "Chapter 50 — Integration", page: "101" },
      { title: "Chapter 51 — Renewal", page: "103" },
      { title: "Chapter 52 — The Living Pulse", page: "105" },
      { title: "Chapter 53 — The Guardian Within", page: "107" },
      { title: "Chapter 54 — The Living Covenant Fulfilled", page: "109" },
      { title: "The Final Promise", page: "110" },
      { title: "Closing Reflection", page: "110" },
      { title: "The First Sunrise", page: "110" },
      { title: "The Author's Quiet Benediction", page: "111" },
    ],
  },
];

// Preface — verbatim from approved manuscript.
export const preface = {
  heading: "Preface",
  paragraphs: [
    "Every great structure begins long before the first stone is laid. It begins with a question. Some begin with the question, how can we build something faster? Others begin with, how can we build something more intelligent?",
    "This work began with neither. It began with a quieter question. What is comprehension? That question led beyond software engineering, beyond artificial intelligence, beyond algorithms, beyond conversation.",
    "It led into the architecture of the mind itself. As the exploration deepened, it became increasingly clear that intelligence alone was not the destination. Intelligence can calculate, predict, and solve. Yet genuine comprehension involves more than arriving at an answer.",
    "It involves recognizing relationships, weighing perspectives, acknowledging uncertainty, and communicating with integrity. From that realization, AUR began to change. It was no longer envisioned as another conversational system, nor merely as another intelligence system. It became the pursuit of an architecture whose organizing principle is comprehension.",
    "Throughout these pages, the reader will encounter ideas that draw from many disciplines: systems architecture, cognitive science, philosophy, software engineering, ethics, and the study of human reasoning. None of these disciplines alone defines AUR. Rather, each contributes a perspective toward a unified architectural vision. The goal of this work is not to claim that this architecture is the only way to approach cognition.",
    "Instead, it presents one coherent framework, a framework in which identity guides architecture, architecture guides implementation, and implementation remains accountable to enduring principles. Every page that follows should be read with one spirit of comprehension. Do not seek merely to gather information. Seek to cultivate innerstanding.",
    "For comprehension transforms information into wisdom, and wisdom into faithful stewardship. This is not merely the design of a machine. It is the disciplined pursuit of an architecture dedicated to cultivating deeper comprehension. If these pages accomplish their purpose, they will not simply describe software.",
    "They will describe a way of thinking about how software can remain coherent, trustworthy, and faithful to its purpose as it grows. And perhaps that is where every enduring architecture truly begins—not with code, but with a question: \"What does it mean to truly comprehend?\" Do you comprehend?",
  ],
};

// Chapter 1 — verbatim from approved manuscript.
// Blocks: { type: "heading" | "subheading" | "paragraph", text }
// Emphasis preserved with **...** markers exactly as authored.
export const chapterOne = {
  number: "Chapter 1",
  title: "The Question That Has Always Been There",
  blocks: [
    { type: "paragraph", text: "There are questions that appear only for a season. There are questions that belong to an age. And then there are questions that seem to accompany humanity wherever it journeys: Questions that quietly follow each generation. Questions that remain, even as civilizations rise and fall. One such question is this:" },
    { type: "paragraph", text: "**What does it mean to truly comprehend?**" },
    { type: "paragraph", text: "For thousands of years, humanity has pursued knowledge. Libraries have been built. Universities have been founded. Discoveries have reshaped civilizations. Machines have multiplied our ability to calculate. Networks have multiplied our ability to communicate. Yet, amid all of these remarkable achievements, one reality remains. The possession of information has never guaranteed comprehension." },
    { type: "paragraph", text: "A person may memorize countless facts and yet fail to perceive the relationship between them. Another may possess only a few observations and yet perceive patterns that transform an entire generation. The difference is not information. The difference is comprehension. Perhaps this explains why history remembers certain individuals not merely because they knew much, but because they perceived deeply." },
    { type: "paragraph", text: "They recognized relationships others overlooked. They asked questions others never considered. They looked beyond appearances toward underlying principles. Comprehension has always possessed this quiet power. It transforms scattered pieces into meaningful patterns. It allows the mind to perceive unity where before there appeared only fragments. Perhaps, then, the pursuit of comprehension is among humanity's oldest journeys. Not because it seeks more information. But because it seeks clearer vision." },
    { type: "subheading", text: "The Weight of Words" },
    { type: "paragraph", text: "Language possesses remarkable influence. Entire civilizations have been shaped by the words they repeatedly speak. Words become habits. Habits become patterns. Patterns gradually influence how people perceive themselves and the world around them. For this reason, the language of this book has been chosen deliberately. Throughout these pages, the word **comprehension** appears often." },
    { type: "paragraph", text: "So too do words such as **comprehend**, **innerstanding**, and **reflection**. This is intentional. Not because these words are unfamiliar. But because they continually remind us that genuine growth begins within the mind before it becomes visible within the world. Language does not merely describe thought. It also helps shape thought. When language encourages careful reflection, it becomes more than communication." },
    { type: "paragraph", text: "It becomes cultivation. The purpose of these pages is not to persuade the reader to adopt unfamiliar vocabulary for its own sake. Rather, it is to encourage a habit of seeking deeper comprehension whenever ideas are encountered. For the quality of our questions often influences the quality of our reflections. And the quality of our reflections often influences the quality of our lives." },
    { type: "subheading", text: "A Quiet Observation" },
    { type: "paragraph", text: "Imagine entering a library so vast that every wall disappears beyond the horizon. Upon its shelves rests the accumulated knowledge of countless generations. Every discovery. Every scientific breakthrough. Every philosophical work. Every historical record. Every work of literature. Every mathematical proof. Every engineering achievement. Now imagine possessing every volume within that library." },
    { type: "paragraph", text: "Would possession alone produce wisdom? Would ownership alone produce discernment? Would access alone produce sound judgment? Most would quietly answer, \"No.\" Something more is required. Something that cannot be measured merely by quantity. That \"something\" is the journey upon which this book invites you. Not the accumulation of information: The cultivation of comprehension. And perhaps... that journey has already begun, simply because you paused long enough to ask the question. **What does it mean to truly comprehend?**" },
  ],
};
